<template>
  <div class="internal-parts-listing">
    <v-layout class="p-2 pr-0 border-bottom-light-grey min-height-57px">
      <v-flex class="d-flex font-level-3-bold my-auto">
        <span class="form-title font-size-20"> Available </span>
      </v-flex>
      <v-flex
        class="d-flex font-level-3-bold my-auto"
        style="justify-content: end"
      >
        <v-btn
          :disabled="pageLoading"
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          depressed
          @click="openSerialNumberDialog(productInfo.isSerialized)"
        >
          <v-icon size="20">mdi-plus</v-icon>
          Add
        </v-btn>
      </v-flex>
    </v-layout>

    <v-simple-table fixed-header height="67vh">
      <template v-slot:default>
        <thead>
          <tr>
            <!-- <th width="50" class="simple-table-th">#</th> -->
            <th class="simple-table-th">Serial Number</th>
            <th class="simple-table-th">Inbond Date</th>
            <th class="simple-table-th">Inbond Doc #</th>
            <th class="simple-table-th">Outbond Date</th>
            <th class="simple-table-th">Outbond #</th>
            <th class="simple-table-th">Action</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="inventoryData.length > 0">
            <tr
              v-for="(row, index) in inventoryData"
              :key="index"
              :class="{
                'custom-border-top': index == 0,
                'orange_lighten-5': index % 2 == 0,
              }"
            >
              <!-- <td class="simple-table-td">
                {{ index + 1 }}
              </td> -->
              <td class="simple-table-td pl-4">
                <template v-if="row.text">
                  <showBarcode
                    :barcodeUrl="row.barcode_image"
                    :barcode-text="row.text"
                    title="Barcode"
                  />
                  <span class="mr-1 text-capitalize">{{ row.text }}</span>
                </template>

                <template v-else>
                  <em class="text-muted">no Serial no.</em>
                </template>
              </td>
              <td class="simple-table-td pl-4">
                <template v-if="inbondDate">
                  {{ formatDate(inbondDate) }}
                </template>
                <template v-else>
                  <em class="text-muted">no inbond date</em>
                </template>
              </td>
              <td class="simple-table-td pl-4 text-capitalize">
                <template v-if="inbondDoc">
                  {{ inbondDoc }}
                </template>
                <template v-else>
                  <em class="text-muted">no inbond doc</em>
                </template>
              </td>
              <td class="simple-table-td pl-4 text-capitalize">
                <template
                  v-if="
                    row.serialize_number_item &&
                    row.serialize_number_item.length > 0
                  "
                >
                  {{ row.serialize_number_item[0].ticket_created_at }}
                </template>

                <em v-else class="text-muted"> no outbond date </em>
              </td>
              <td class="simple-table-td pl-4">
                <template
                  v-if="
                    row.serialize_number_item &&
                    row.serialize_number_item.length > 0
                  "
                >
                  {{ row.serialize_number_item[0].main_parent_barcode }}
                </template>
                <template v-else>
                  <em class="text-muted">no outbond no</em>
                </template>
              </td>
              <td class="simple-table-td pl-4" v-if="!row.serialize_number_item || row.serialize_number_item?.length <= 0">
                  <v-icon small class="mr-2" color="cyan" v-on:click="editSerial(row)">mdi-pencil</v-icon>
                  <v-icon small color="red lighten-1" v-on:click="deleteSerialRow(row)">mdi-delete</v-icon>
              </td>
              <td class="simple-table-td pl-4" v-else></td>
            </tr>
          </template>
          <template v-else>
            <template v-if="pageLoading">
              <tr v-for="row in 3" :key="row">
                <!-- <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td> -->
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
                <td>
                  <v-skeleton-loader
                    type="text"
                    class="custom-skeleton table-rows-text"
                  ></v-skeleton-loader>
                </td>
              </tr>
            </template>
            <tr v-else-if="!pageLoading">
              <td colspan="5">
                <p
                  class="m-0 row-not-found text-center font-weight-500 font-size-16"
                >
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  Uhh... There are no price at the moment.
                </p>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <ListingFooter
      :dataLoading="pageLoading"
      :currentPage="current_page"
      :totalPages="total_pages"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="total_rows"
      removePage
    ></ListingFooter>
    <CreateOrUpdateSerialNo
      v-if="addInventoryDialog"
      :dialogStatus="addInventoryDialog"
      :productId="type_id"
      :serialized="Number(serialized)"
      @close:dialog="closeSerialNumberDialog"
      @update:serial-numbers="refreshInventory"
    ></CreateOrUpdateSerialNo>
    <DeleteDialog :delete-dialog="deleteSerialDialog">
      <template v-slot:title>Delete Confirmation</template>
        <template v-slot:text>
          <h3
            class="font-weight-500 delete-text"
            style="font-size: 20px !important"
          >
            Are you sure you want to delete serial number
            <span class="font-weight-700">{{ selectedDeleteSerial?.text }}</span>
            ?
          </h3>
        </template>
        <template v-slot:action>
          <v-btn
            depressed
            :disabled="deleteSerialLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="deleteSerialDialog = false"
            >No! Cancel</v-btn
          >
          <v-btn
            depressed
            :disabled="deleteSerialLoading"
            :loading="deleteSerialLoading"
            color="red lighten-1 white--text"
            v-on:click="deleteSerialConfirm()"
            class="mx-2 custom-grey-border custom-bold-button"
            >Yes! Delete</v-btn
          >
      </template>
  </DeleteDialog>
  <Dialog :common-dialog="editSerialDialog" :dialog-width="600">
  <template v-slot:title> Edit Serial Number </template>
  <template v-slot:body>
    <v-container class="px-10" fluid>
      <v-form
        ref="editSerialForm"
        v-model.trim="editSerialFormValid"
        lazy-validation
        v-on:submit.stop.prevent="updateSerialConfirm()"
      >
        <v-layout class="my-4">
          <v-flex md12>
            <label class="font-weight-500 font-size-16 required"
              >Serial Number</label
            >
            <v-text-field
              v-model="editSerialData.text"
              placeholder="Serial Number"
              solo
              flat
              color="cyan"
              dense
              :rules="[
                validateRules.required(editSerialData.text, 'Serial Number'),
              ]"
              :error-messages="editSerialErrors.text"
              v-on:keyup="editSerialErrors.text = null"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </template>
  <template v-slot:action>
    <v-btn
      depressed
      :disabled="editSerialLoading"
      v-on:click="closeEditSerialDialog()"
      class="mx-2 custom-grey-border custom-bold-button"
    >
      No! Close
    </v-btn>
    <v-btn
      depressed
      v-on:click="updateSerialConfirm()"
      :disabled="editSerialLoading || !editSerialFormValid"
      :loading="editSerialLoading"
      class="mx-2 custom-bold-button white--text"
      color="cyan"
    >
      Yes! Update
    </v-btn>
  </template>
</Dialog>
  </div>
  
</template>

<script>
import { QUERY,DELETE,PATCH  } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingFooter from "@/view/pages/partials/Listing-Footer";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import showBarcode from "@/view/components/showBarcode.vue";
import CreateOrUpdateSerialNo from "@/view/pages/partials/Create-Or-Update-SerialNumber";
import DeleteDialog from "@/view/pages/partials/Delete";
import Dialog from "@/view/pages/partials/Dialog";
import ValidationMixin from "@/core/plugins/validation-mixin";
// import moment from "moment-timezone";

export default {
  mixins: [CommonMixin,ValidationMixin],
  data() {
    return {
      dates: [],
      addInventoryDialog: false,
      pageLoading: false,
      inventoryData: new Array(),
      filter: {
        search: null,
      },
      per_page: 15,
      current_page: 1,
      offset: 0,
      total_pages: 0,
      total_rows: 0,
      serialized: 0,
      deleteSerialDialog: false,
      deleteSerialLoading: false,
      selectedDeleteSerial: {},
      editSerialDialog: false,
      editSerialFormValid: true,
      editSerialLoading: false,
      editSerialData: {
        id: null,
        text: null,
      },
      editSerialErrors: {
        text: null,
      },
    };
  },
  components: {
    ListingFooter,
    showBarcode,
    CreateOrUpdateSerialNo,
    DeleteDialog,
    Dialog
  },
  props: {
    type: {
      required: true,
      type: String,
      default: "",
    },
    productInfo: {
      required: true,
      type: Object,
      default: () => {},
    },
    type_id: {
      required: true,
      type: Number,
      default: 0,
    },
    inbondDate: {
      type: String,
      default: null,
    },
    inbondDoc: {
      type: String,
      default: null,
    },
  },
  watch: {
    type_id() {
      let type_id = this.lodash.toSafeInteger(this.type_id);
      if (type_id > 0) {
        this.getProductInventory(type_id);
      }
    },
  },
  methods: {


     deleteSerialRow(row) {
        this.selectedDeleteSerial = row;
        this.deleteSerialDialog = true;
      },
      deleteSerialConfirm() {
        const _this = this;
        _this.deleteSerialLoading = true;
        _this.$store
          .dispatch(DELETE, { url: `product-serial-number/${_this.selectedDeleteSerial.id}` })
          .then(() => {
            _this.deleteSerialDialog = false;
            _this.selectedDeleteSerial = {};
            _this.getProductInventory(_this.type_id);
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.deleteSerialLoading = false;
          });
      },

      editSerial(row) {
        this.editSerialData = {
          id: row.id,
          text: row.text,
        };
        this.editSerialErrors = { text: null };
        this.editSerialDialog = true;
      },

      closeEditSerialDialog() {
        this.editSerialDialog = false;
        this.editSerialData = { id: null, text: null };
        this.editSerialErrors = { text: null };
      },
      
      updateSerialConfirm() {

      const _this = this;
      if (!_this.$refs.editSerialForm.validate()) {
        return;
      }
      _this.editSerialLoading = true;
      _this.$store
      .dispatch(PATCH, {
        url: `product-serial-number/${_this.editSerialData.id}`,
        data: {
          text: _this.editSerialData.text,
        },
      })
      .then(() => {
        _this.closeEditSerialDialog();
        _this.getProductInventory(_this.type_id);
      })
      .catch((error) => {
        if (error?.response?.data?.errors?.text) {
          _this.editSerialErrors.text = error.response.data.errors.text[0];
        } else {
          _this.logError(error);
        }
      })
    .finally(() => {
      _this.editSerialLoading = false;
    });
},
    openSerialNumberDialog(serialized) {
      this.serialized = serialized;
      this.addInventoryDialog = true;
    },
    closeSerialNumberDialog() {
      this.addInventoryDialog = false;
    },
    refreshInventory() {
      this.getProductInventory(this.type_id);
    },
    getProductInventory(productId) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(QUERY, {
          url: `all-serial-number/${this.type}/${productId}`,
          data: {
            //type: _this.type,
            per_page: _this.per_page,
            current_page: _this.current_page,
          },
        })
        .then((data) => {
          this.inventoryData = data.data.rows;
          _this.offset = data.data.offset;
          _this.total_pages = Math.ceil(
            data.data.total_rows / data.data.per_page
          );
          _this.current_page = data.data.current_page;
          _this.total_rows = data.data.total_rows;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination");
  },
  mounted() {
    const _this = this;
    let type_id = _this.lodash.toSafeInteger(_this.type_id);
    if (type_id > 0) {
      _this.getProductInventory(type_id);
    }

    PaginationEventBus.$on("update:pagination", (param) => {
      _this.current_page = param;
      _this.getProductInventory(_this.type_id);
    });
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.inventoryData) === false
        ? this.offset + 1
        : 0;
    },
    showingTo() {
      return this.offset + (this.inventoryData ? this.inventoryData.length : 0);
    },
  },
};
</script>
